import { resolveErrorMessage } from "@Components/Error/Error";
import { sendPasswordResetEmail } from "@Http/send_password_reset_email";
import { useMutation } from "@tanstack/react-query";
import { MutationError } from "@Types/index";
import { toast } from "react-toastify";

export const usePasswordReset = (onSuccess: () => void) => {
  const mutation = useMutation<string, MutationError, { email: string }>(
    sendPasswordResetEmail(),
    {
      onSuccess,
      onError: (e) => {
        toast.error(
          resolveErrorMessage(e) ??
            "Something went wrong during password reset link generation!",
          {
            position: "top-center",
          }
        );
      },
    }
  );
  return {
    sendPasswordResetEmail: mutation.mutateAsync,
    loading: mutation.isLoading,
    success: mutation.isSuccess,
    error: mutation.error,
  };
};
